import { Button, Checkbox, Popconfirm, Select, Switch, Table } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import LabelInput from '../LabelNameInput';
import {
  DragHandle,
  SortableContainer,
  SortableItem
} from './DraggableComponents';
import style from './index.scss';
import VisibilityButton from './VisibilityButton';

const ADD_MODE = 'ADD_MODE';
const EDIT_MODE = 'EDIT_MODE';

class GroupPanelTable extends React.Component {
  DraggableBodyRow = ({ className, style, ...restProps }) => {
    const { items } = this.props;
    // function findIndex base on Table rowKey props and should always be a right array index
    const index = items.findIndex((x) => x.index === restProps['data-row-key']);
    return <SortableItem index={index} {...restProps} />;
  };

  renderColumnItemSelections = () => {
    const { columnNames } = this.props;
    if (Array.isArray(columnNames)) {
      return columnNames.map((columnItem, columnItemIndex) => {
        return (
          <Select.Option key={columnItemIndex} value={columnItem.value}>
            {columnItem.label}
          </Select.Option>
        );
      });
    }

    return null;
  };

  renderColumnNameColumn = (text, item) => {
    const { onColumnNameChange, isGroupDefault } = this.props;
    if (item) {
      if (item.isAdding) {
        return (
          <div>
            <Select
              showSearch
              style={{
                width: 200,
                borderColor: item.itemNameErrorMessage ? 'red' : ''
              }}
              placeholder="Item name"
              optionFilterProp="children"
              onChange={(value) => onColumnNameChange(value, item, ADD_MODE)}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              value={item.itemName}>
              {this.renderColumnItemSelections()}
            </Select>
            <p style={{ color: 'red', fontSize: '10px' }}>
              {item.itemNameErrorMessage}
            </p>
          </div>
        );
      }

      if (item.isEditing && !isGroupDefault) {
        const { editData } = item;
        return (
          <div>
            <Select
              showSearch
              style={{
                width: 200,
                borderColor: editData.itemNameErrorMessage ? 'red' : ''
              }}
              placeholder="Item name"
              optionFilterProp="children"
              onChange={(value) => onColumnNameChange(value, item, EDIT_MODE)}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              value={editData.itemName}>
              {this.renderColumnItemSelections()}
            </Select>
            <p style={{ color: 'red', fontSize: '10px' }}>
              {editData.itemNameErrorMessage}
            </p>
          </div>
        );
      }
    }
    return text || item.editData?.itemName;
  };

  renderLabelNameColumn = (text, item) => {
    const { focusedLabelNameIndex, onItemLabelChange } = this.props;

    if (item) {
      if (item.isAdding) {
        return (
          <div>
            <LabelInput
              hasError={item.labelNameErrorMessage}
              item={item}
              isFocused={focusedLabelNameIndex === item.index}
              editMode={ADD_MODE}
              onItemLabelChange={onItemLabelChange}
              labelNameValue={item.labelName}
            />
            <p style={{ color: 'red', fontSize: '10px' }}>
              {item.labelNameErrorMessage}
            </p>
          </div>
        );
      }

      if (item.isEditing) {
        const { editData } = item;
        return (
          <div>
            <LabelInput
              hasError={editData.labelNameErrorMessage}
              item={item}
              isFocused={focusedLabelNameIndex === item.index}
              editMode={EDIT_MODE}
              onItemLabelChange={onItemLabelChange}
              labelNameValue={editData.labelName}
            />
            <p style={{ color: 'red', fontSize: '10px' }}>
              {editData.labelNameErrorMessage}
            </p>
          </div>
        );
      }
    }

    return text;
  };

  renderItemVisibilityToggle = (text, item) => {
    const { onToggleItemVisiblity } = this.props;
    if (item) {
      if (item.isAdding) {
        return (
          <Switch
            onChange={() => onToggleItemVisiblity(item, ADD_MODE)}
            checked={item.isVisible}
          />
        );
      } else if (item.isEditing) {
        return (
          <Switch
            onChange={() => onToggleItemVisiblity(item, EDIT_MODE)}
            checked={item.editData.isVisible}
          />
        );
      }
    }

    return (
      <Switch
        onChange={() => onToggleItemVisiblity(item, ADD_MODE, true)}
        checked={item.isVisible}
      />
    );
  };

  renderItemAction = (item) => {
    const {
      isGroupDefault,
      onConfirmAddItem,
      onConfirmEditItem,
      onEditItem,
      onConfirmDeleteItem
    } = this.props;
    if (item) {
      if (item.isAdding) {
        return (
          <Button
            onClick={() => onConfirmAddItem(item)}
            style={{ color: '#0C8ED7' }}
            type="link">
            <i className="fa fa-check"></i>
          </Button>
        );
      }

      if (item.isEditing) {
        return (
          <Button
            onClick={() => onConfirmEditItem(item)}
            style={{ color: '#0C8ED7' }}
            type="link">
            <i className="fa fa-check"></i>
          </Button>
        );
      }

      return (
        <div className="row" style={{ fontSize: '18px' }}>
          <div className="col-md-2">
            <VisibilityButton
              item={item}
              onToggleItemVisiblity={this.props.onToggleItemVisiblity}
              addMode={ADD_MODE}
              editMode={EDIT_MODE}
            />
          </div>

          <div className="col-md-2">
            <a onClick={() => onEditItem(item)} style={{ color: '#748AA1' }}>
              <i className="fa fa-edit"></i>
            </a>
          </div>

          {!isGroupDefault && (
            <div className="col-md-3">
              <Popconfirm
                title="Are you sure to delete this item?"
                onConfirm={() => onConfirmDeleteItem(item)}
                onCancel={() => {}}
                okText="Yes"
                cancelText="No">
                <a style={{ color: '#DF6057' }}>x</a>
              </Popconfirm>
            </div>
          )}
        </div>
      );
    }

    return null;
  };

  isOperationPermitted = (isEnabledField, itemName) => {
    const { columnNames } = this.props;
    const field = columnNames.find((c) => c.itemName === itemName);
    return field ? field[isEnabledField] : false;
  };

  renderOperationFlagToggle = (isEnabledField, valueField, record) => {
    const { onToggleItemOperation } = this.props;
    if (record.isEditing) {
      return (
        <Checkbox
          checked={record.editData[valueField]}
          disabled={!this.isOperationPermitted(isEnabledField, record.itemName)}
          onChange={() =>
            onToggleItemOperation(record, valueField, EDIT_MODE, false)
          }
        />
      );
    }

    return (
      <Checkbox
        checked={record[valueField]}
        disabled={!this.isOperationPermitted(isEnabledField, record.itemName)}
        onChange={() =>
          onToggleItemOperation(record, valueField, ADD_MODE, !record.isAdding)
        }
      />
    );
  };

  render() {
    const { items, onSortEnd } = this.props;

    const columns = [
      {
        title: 'Item',
        dataIndex: 'itemName',
        className: `${style.dragVisible} ${style.editableCell}`,
        key: 'itemName',
        render: (text, record) => this.renderColumnNameColumn(text, record)
      },
      {
        title: 'Label',
        dataIndex: 'labelName',
        className: `${style.dragVisible} ${style.editableCell}`,
        key: 'labelName',
        render: (text, record) => this.renderLabelNameColumn(text, record)
      },
      {
        title: (
          <>
            <i className="fa fa-filter" /> Filterable
          </>
        ),
        dataIndex: 'filterEnabled',
        className: style.editableCell,
        key: 'filterEnabled',
        render: (text, record) =>
          this.renderOperationFlagToggle(
            'isFilterable',
            'filterEnabled',
            record
          )
      },
      {
        title: (
          <>
            <i className="fa fa-search" /> Searchable
          </>
        ),
        dataIndex: 'searchEnabled',
        className: style.editableCell,
        key: 'searchEnabled',
        render: (text, record) =>
          this.renderOperationFlagToggle(
            'isSearchable',
            'searchEnabled',
            record
          )
      },
      {
        title: (
          <>
            <i className="fa fa-sort" /> Sortable
          </>
        ),
        dataIndex: 'sortEnabled',
        className: style.editableCell,
        key: 'sortEnabled',
        render: (text, record) =>
          this.renderOperationFlagToggle('isSortable', 'sortEnabled', record)
      },
      {
        title: 'Action',
        className: style.editableCell,
        key: 'action',
        render: (text, record) => this.renderItemAction(record)
      },
      {
        title: '',
        dataIndex: 'sort',
        width: 30,
        className: `${style.dragVisible} ${style.editableCell} ${style.dragIcon}`,
        render: () => <DragHandle />
      }
    ];

    const DraggableContainer = (props) => (
      <SortableContainer
        useDragHandle
        helperClass={style.rowDragging}
        onSortEnd={onSortEnd}
        {...props}
      />
    );

    return (
      <Table
        pagination={false}
        bordered={false}
        columns={columns}
        dataSource={items}
        rowKey="index"
        components={{
          body: {
            wrapper: DraggableContainer,
            row: this.DraggableBodyRow
          }
        }}
      />
    );
  }
}

/**
 * Proptypes
 * @type {
 * items
 * isGroupDefault
 * focusedLabelNameIndex
 * columnNames
 * onItemLabelChange
 * onConfirmAddItem
 * onConfirmEditItem
 * onEditItem
 * onToggleItemVisiblity
 * onConfirmDeleteItem
 * onColumnNameChange
 * onSortEnd
 * }
 */
GroupPanelTable.propTypes = {
  items: PropTypes.array.isRequired,
  isGroupDefault: PropTypes.bool.isRequired,
  focusedLabelNameIndex: PropTypes.number,
  columnNames: PropTypes.array.isRequired,
  labelDictionary: PropTypes.object,
  onItemLabelChange: PropTypes.func.isRequired,
  onConfirmAddItem: PropTypes.func.isRequired,
  onConfirmEditItem: PropTypes.func.isRequired,
  onEditItem: PropTypes.func.isRequired,
  onToggleItemVisiblity: PropTypes.func.isRequired,
  onConfirmDeleteItem: PropTypes.func.isRequired,
  onColumnNameChange: PropTypes.func.isRequired,
  onSortEnd: PropTypes.func.isRequired,
  onToggleItemOperation: PropTypes.func
};

export default GroupPanelTable;
